
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import {
  AppXState,
  AttachDrawer,
  DetachDrawer,
  Logout,
  SetIsMobile,
  SetBlockUi,
  OpenDrawerMobile,
  OpenDrawer,
  CloseDrawerMobile,
  CloseDrawer,
} from './../../state';
import { IAppUi, IServerConfig, IAppSession, AppCurrentFlowStore } from '../../store';
import { buildUrlChangePasswordPunku } from '../../functions';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material';
import { interval } from 'rxjs';
import { async } from 'rxjs/internal/scheduler/async';

@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  readonly state$ = this.store.select(AppXState.state);

  _fillerNav = Array.from({ length: 4 }, (_, i) => `Nav Item ${i + 1}`);

  fillerNav = [
    {
      id: 'M1_INICIO',
      'nombre': 'Inicio',
      'icono': 'home',
      'url': '/workflow/inicio',
      checked: false,
      isSubmenu: true,
      isMostrar: false
    }, {
      id: 'M2_BANDEJA',
      'nombre': 'Bandeja',
      'icono': 'content_paste_search',
      'url': '/workflow/bandeja',
      checked: false,
      isSubmenu: true,
      isMostrar: false
    },
    {
      id: 'S1_CONSULTA',
      'nombre': 'Consulta',
      'icono': 'create_new_folder',
      'url': '/workflow/trazabilidad',
      checked: false,
      isSubmenu: true,
      isMostrar: false,
      //sistemaMenuList: [

      //  {
      //    id: 'M1',
      //    'nombre': 'Trazabilidad',
      //    'icono': 'query_stats',
      //    'url': '/workflow/trazabilidad',
      //    checked: false,
      //    isSubmenu: true,
      //    isMostrar: false
      //  },
      //  {
      //    id: 'M2',
      //    'nombre': 'Visor',
      //    'icono': 'preview',
      //    'url': '/workflow/visor',
      //    checked: false,
      //    isSubmenu: true,
      //    isMostrar: false
      //  }

      //]
    }, {
      id: 'M3_ADMINISTRACION',
      'nombre': 'Administración',
      'icono': 'admin_panel_settings',
      'url': '/administracion',
      checked: false,
      isSubmenu: true,
      isMostrar: false
    }

  ];

  mobileQuery: MediaQueryList;

  @ViewChild('snav') sidenav: MatSidenav;

  private _mobileQueryListener: () => void;

  isOpenNav: boolean = false
  hidden: boolean = false;
  constructor(
    private store: Store,
    public router: Router, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private storeCurrent: AppCurrentFlowStore,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    const session = this.store.selectSnapshot<IAppSession>(
      (state) => state.appStore.session
    );
    const { defaultRol, email } = session.user;

    interval(800).subscribe(() => {
      this.fillerNav.forEach((temp) => {
        if (defaultRol.GUID_ROL.toUpperCase() == 'A9601149-1A0E-4342-8864-A2101B4ECC1B' // Representante Legal
          || defaultRol.GUID_ROL.toUpperCase() == 'E7C9601E-9E0B-4BCE-ABF4-6D7AD0CAE606') { // Registrador
          if (temp.id == 'M1_INICIO' || temp.id == 'M2_BANDEJA' || temp.id == 'S1_CONSULTA') {
            temp.isMostrar = true;
          }
        }
        else if (defaultRol.GUID_ROL.toUpperCase() == '21ACF085-B930-4088-9507-449AA1027199') { // Responsable UACTD
          if (temp.id == 'M1_INICIO' || temp.id == 'M2_BANDEJA') {
            temp.isMostrar = true;
          }
        }
        else if (defaultRol.GUID_ROL.toUpperCase() == '0E98D3F3-96D5-43E1-B513-9334516CFE33') { // Asesoría Jurídica
          if (temp.id == 'M2_BANDEJA') {
            temp.isMostrar = true;
          }
        }
        else if (defaultRol.GUID_ROL.toUpperCase() == 'E73108E7-CC8B-4D03-B542-B232ADAFCEF2') { // Consultas DILIC
          if (temp.id == 'S1_CONSULTA') {
            temp.isMostrar = true;
          }
        } else if (defaultRol.GUID_ROL.toUpperCase() == '0A264A01-C3FE-4F58-B9B1-136404484CC5') { // Administrador
          if (temp.id == 'M3_ADMINISTRACION') {
            temp.isMostrar = true;
          }
        }
        // Todos los demas roles de DILIC
        else {
          //else if (defaultRol.GUID_ROL.toUpperCase() == 'BFA12727-33F1-4F05-963C-F5EA669FF0E2'
          //  || defaultRol.GUID_ROL.toUpperCase() == '53CF1D5F-1B8C-43D8-A2C3-ECBA5F3122E1'
          //  || defaultRol.GUID_ROL.toUpperCase() == '7D1A2185-465F-4859-85B3-EE9A503C9089'
          //  || defaultRol.GUID_ROL.toUpperCase() == '6A312BDD-9D02-44C0-B432-C3470B095781') {
          if (temp.id == 'M2_BANDEJA' || temp.id == 'S1_CONSULTA') {
            temp.isMostrar = true;
          }
        }
      })
    });

  }



  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnInit() {
    console.log("state.ui.appMenu ", this.store.select(AppXState.state))
  }

  handleToogleDrawer = (open) => {
    const ui = this.store.selectSnapshot<IAppUi>(state => state.appStore.ui);
    if (open) {
      if (ui.isMobile) {
        this.store.dispatch(new OpenDrawerMobile());
      } else {
        this.store.dispatch(new OpenDrawer());
      }
    } else {
      if (ui.isMobile) {
        this.store.dispatch(new CloseDrawerMobile());
      } else {
        this.store.dispatch(new CloseDrawer());
      }
    }
  }

  openOpcion(opcion: any) {
    if (!opcion.isSubmenu) {
      opcion.checked = !opcion.checked;
    }
  }


  public closeNav() {
    this.isOpenNav = false;
    // this.sidenav.close();
  }

  public openNav() {
    this.isOpenNav = true;
    // this.sidenav.open();
  }

  handleToogleAttachDrawer = (open) => {
    if (open) { this.store.dispatch(new AttachDrawer()); } else { this.store.dispatch(new DetachDrawer()); }
  }

  handleLogout = () => {
    this.store.dispatch(new Logout());
  }

  handleChangeMobileSize = (isMobile: boolean) => {
    this.store.dispatch(new SetIsMobile(isMobile));
  }

  handleClickLogo = () => {
    this.router.navigate(['/']);
  }

  handleClickChangePassword = () => {
    this.store.dispatch(new SetBlockUi(true));
    const session = this.store.selectSnapshot<IAppSession>(state => state.appStore.session);
    const { punku } = this.store.selectSnapshot<IServerConfig>(state => state.appStore.globalConfig.configuration);
    window.location.href = buildUrlChangePasswordPunku(punku, session.token);
  }

  shouldRun = /(^|.)(stackblitz|webcontainer).(io|com)$/.test(window.location.host);
}
